import React, { useState } from 'react';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const headerBackgroundStyle = {
    backgroundImage: 'url(/images/SeattleView.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '160px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return (
    <header className="App-header" role="banner">
      <div className="header-background" style={headerBackgroundStyle}>
        <div className="header-overlay">
          <h1>Dina's Guide to Jewish Seattle</h1>
        </div>
      </div>
      <nav role="navigation" aria-label="Main navigation">
        <button 
          className="hamburger-menu"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={isMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        <ul className={isMenuOpen ? 'nav-open' : ''}>
          <li><a href="#introduction" onClick={closeMenu}>Introduction</a></li>
          <li><a href="#neighborhoods" onClick={closeMenu}>Neighborhoods</a></li>
          <li><a href="#housing" onClick={closeMenu}>Housing</a></li>
          <li><a href="#mikvaot" onClick={closeMenu}>Mikvaot</a></li>
          <li><a href="#kosher-food" onClick={closeMenu}>Kosher Food</a></li>
          <li><a href="#networking" onClick={closeMenu}>Networking</a></li>
          <li><a href="#news" onClick={closeMenu}>News</a></li>
          <li><a href="#schools" onClick={closeMenu}>Schools</a></li>
          <li><a href="#visiting" onClick={closeMenu}>Visiting</a></li>
          <li><a href="#resources" onClick={closeMenu}>Resources</a></li>
        </ul>
      </nav>
    </header>
  );
}

export default Header; 